module.exports = __webpack_public_path__ + "img/tjaula.257f9f00.jpeg";